import { IdbDatabase } from '#ui-shared/idb-object-store/idb-database';

/**
 * The IndexedDB database instance used for symbol caching. This database is shared between multiple stores, so that they can coordinate cache invalidation and avoid redundant data storage.
 */
export const symbolDatabase = new IdbDatabase({
  name: 'nora-symbols',
  version: 1,
});
